import { NormalizeApi } from "../normalizeApi";
const BASE_ENDPOINT = 'users.manage';
/**
 * Send push notifications
 *
 * @param {SearchQuery} searchQuery
 *
 * @return {Promise<{response: {response: Response, json: any}}|{error: (*|string)}>}
 */
// function sendPush(searchQuery) {
// 	searchQuery.addRequestOptions({
// 		method: 'POST',
// 	}, true)
// 	return callApi(`/v1/customers/send-push-notifications`, searchQuery)
// }

export const CustomersApi = NormalizeApi({
  create: `${BASE_ENDPOINT}.create`,
  view: `${BASE_ENDPOINT}.view`,
  list: `${BASE_ENDPOINT}.list`,
  update: `${BASE_ENDPOINT}.update`,
  delete: `${BASE_ENDPOINT}.delete`,
  uploadAvatar: `${BASE_ENDPOINT}.settings.upload-avatar`,
  deleteAvatar: `${BASE_ENDPOINT}.settings.delete-avatar`,
  sendPush: () => ({})
});